import React, { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { Apis } from "../util/Apis";
import AuthContext from "../components/login/store/AuthContext";
import { logoutUser } from "../components/login/actions/authentication.action";

import { Card, CardHeader, Loading, PageWrapper } from "../components/blocks";
import { LuUser } from "react-icons/lu";
import { Button, Input, Label } from "../components/atoms";

const Perfil = () => {
  const { data: meData, isLoading } = useQuery({
    queryKey: ["me"],
    queryFn: async () => {
      const res = await axios.get(Apis.CAPP + "/me");
      return res.data;
    },
  });

  const { dispatch } = useContext(AuthContext);

  return (
    <PageWrapper>
      {isLoading ? (
        <Loading />
      ) : (
        <div className="flex flex-col w-full gap-4">
          <Card>
            <CardHeader
              title="Perfil"
              subtitle="Informacion básica del cliente"
              icon={<LuUser size={24} />}
            />
            <div className="flex flex-col w-full gap-3">
              <div className="flex flex-col w-full">
                <Label>Nombres</Label>
                <Input type="text" id="nombres" value={meData?.firstName ?? ""} disabled />
              </div>
              <div className="flex flex-col w-full ">
                <Label>Apellidos</Label>
                <Input type="text" id="apellidos" value={meData?.lastName ?? ""} disabled />
              </div>
              <div className="flex flex-col w-full ">
                <Label>Documento</Label>
                <Input type="text" id="documento" value={meData?.document ?? ""} disabled />
              </div>
              <div className="flex flex-col w-full ">
                <Label>Contraseña</Label>
                <Input type="password" id="password" value="******" disabled />
              </div>
            </div>
            <Button className="w-full mt-2" onClick={() => logoutUser(dispatch)}>
              Salir
            </Button>
          </Card>
        </div>
      )}
    </PageWrapper>
  );
};

export default Perfil;
